import { useEffect, useMemo } from "react"
import { useShallow } from "zustand/shallow"

import { findFreightUnit } from "../utils"

import type { UnitOfMeasurement } from "@/graphql/codegen/graphql"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"

export const useFreightUnit = (): UnitOfMeasurement | undefined => {
  const { units, getUnits } = useUnitOfMeasurementsStore(
    useShallow((state) => ({ units: state.units, getUnits: state.getUnits }))
  )
  useEffect(() => {
    if (!units.length) getUnits()
  }, [units.length, getUnits])

  return useMemo(() => findFreightUnit(units), [units])
}
